import { Grid, styled } from '@mui/material';

export const FacilityListPropertyContainer = styled(Grid)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '& strong': {
    paddingRight: theme.spacing(1)
  }
}));

export const FacilityHeaderTitle = styled('div')(() => ({
  maxWidth: 'calc(100% - 500px)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: 'bold',
  height: '60px',
  float: 'left',
  '@media (max-width: 480px)': {
    float: 'none',
    maxWidth: '100%',
    height: '30px',
    lineHeight: '30px'
  }
}));
